<template>
	<div>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Forgot Password</h2>
			</div>
		</div>
		<!-- eo main header -->
		<div class="main-section mgt-40">
			<div class="container">
				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
					<div class="tac">
						<div class="login-box">
							<form @submit.prevent="onSubmit" novalidate="" autocomplete="off">
								<div class="form-group">
									<label for="">
										Email or Phone Number<span class="required">*</span>
									</label>
									<input autocomplete="off" v-model="vModel.Username"
										v-validate="'required|verify_mobile_email'" data-vv-as='Email or Phone'
										v-drag-disable='' :class="{'input': true, 'is-danger': errors.has('Username') }"
										type="email" class="form-control" placeholder="Email or Phone"
										data-vv-name="Username" />
									<div v-show="errors.has('Username')" class="help is-danger">
										{{ errors.first('Username') }}</div>
								</div>
								<div class="form-group" v-if="showDob == 'true'||showDob==true">
									<label for="">
										Date of Birth<span class="required">*</span>
									</label>
									<div>
										<kendo-datepicker class="form-control" id="dobirth" data-vv-name="dobirth"
											v-model="vModel.DateOfBirth" data-vv-as='Date Of Birth'
											onkeydown="return false;" v-validate="'required'" :format="'dd/MM/yyyy'"
											:class="{'input': true, 'is-danger': errors.has('dobirth') }">
										</kendo-datepicker>
									</div>
									<div v-show="errors.has('dobirth')" class="help is-danger">
										{{ errors.first('dobirth') }}
									</div>
								</div>
								<div class="submit-option">
									<div class="left-option">
										<router-link :to="'login'" class="btn submit-lefticon-btn">
											<span class="left-icon">
												<i class="fas fa-angle-left"></i>
											</span>
											<span class="btn-content">Cancel</span>
										</router-link>
									</div>

									<div class="right-option">
										<button class="btn submit-righticon-btn">
											<span class="btn-content">Submit</span>
											<span class="right-icon">
												<i class="fas fa-angle-right"></i>
											</span>
										</button>
									</div>
								</div>
							</form>
						</div>
						<!-- eo login box -->
					</div>
				</div>
				<!-- eo main card -->
			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->
	</div>
</template>
<script>
	import authservice from "../../services/authservice";
	import commonService from "../../services/common";
	// // import welcome from "../../shared/welcome.vue";
	export default {
		name: "forgotpassword",
		components: {
			// welcome
		},

		created() {
			this.showDob = true //commonService.getStorage('forget-password-show-dob');
			console.log(this.showDob)
		},
		data() {
			return {
				vModel: {
					Username: null,
					DateOfBirth: null,
					DateOfBirthMalaysianFormat: null
				}
			};
		},
		beforeRouteEnter(to, from, next) {
			next();
		},
		methods: {
			onVerify: function (response) {
				// this.vModel.ReCaptcha = response;
			},
			onSubmit() {
				var self = this;
				this.$validator.validateAll().then(result => {
					if (result && self.beforeSave()) {
						authservice.forgotPassword(this.vModel.Username, this.vModel.DateOfBirthMalaysianFormat);
					}
				});
			},
			beforeSave() {

				if (this.showDob == 'true'||this.showDob==true) {
					let value = this.vModel.DateOfBirth;

					if(String(value).indexOf('/')==-1){
						let newvalue=new Date(value);
						value = newvalue.getDate() + '/' + (newvalue.getMonth()+1) + '/' + newvalue.getFullYear();
					}
					var pcs = value.split("/");

					this.vModel.DateOfBirthMalaysianFormat = pcs[2] + "-" + pcs[1] + "-" + pcs[0];
					return true;
				} else return true;

			}
		}
	};
</script>